import { FileText } from 'lucide-react';

/**
 * Azure Blob Storage was never provisioned (a Phase 1 gap, unrelated
 * to this feature) - DocumentEngine.uploadToBlob() still intentionally
 * throws. This tab honestly reflects that rather than pretending
 * uploads work with no storage behind them.
 */
export function ProjectDocumentsTab() {
  return (
    <section className="card placeholder-card">
      <h2><FileText size={16} className="inline-icon" /> Documents</h2>
      <p className="muted">
        Document upload and storage will be available once Blob Storage infrastructure is provisioned. Planned
        categories include: Project Proposal, Budget, Donor Agreement, Assessment, MoU, Implementation Plan,
        Reports, Monitoring Reports, and Evaluations.
      </p>
    </section>
  );
}
